import { render, staticRenderFns } from "./gluedDetail.vue?vue&type=template&id=13358a1a"
import script from "./gluedDetail.vue?vue&type=script&lang=js"
export * from "./gluedDetail.vue?vue&type=script&lang=js"
import style0 from "./gluedDetail.vue?vue&type=style&index=0&id=13358a1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports